// A walk-in exit shaped as a rectangle of FEET positions (a gate in a fence), for SceneTransition.
export function inFeetRect(rect, x, feetY) {
  return !!rect && x >= rect.x1 && x <= rect.x2 && feetY >= rect.y1 && feetY <= rect.y2;
}
